import { render } from "./ContentScrollBar.vue?vue&type=template&id=297dabd9"
import script from "./ContentScrollBar.vue?vue&type=script&lang=js"
export * from "./ContentScrollBar.vue?vue&type=script&lang=js"

import "./ContentScrollBar.vue?vue&type=style&index=0&id=297dabd9&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__